export default __webpack_public_path__ + "static/media/1548.56d36ea8.png";